import { useEffect, useRef } from "react";

const SYMBOLS = ["❄", "✦", "❋", "•"];

/**
 * Subtle animated snowflake / sparkle field. Purely decorative; pointer-events: none.
 * Gold + silver sparkle colors.
 */
export default function Snowflakes({ count = 40 }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.innerHTML = "";
    for (let i = 0; i < count; i++) {
      const flake = document.createElement("span");
      flake.className = "snowflake";
      flake.textContent = SYMBOLS[Math.floor(Math.random() * SYMBOLS.length)];
      const size = 8 + Math.random() * 16;
      const left = Math.random() * 100;
      const dur = 14 + Math.random() * 20;
      const delay = -Math.random() * 30;
      const opacity = 0.30 + Math.random() * 0.5;
      flake.style.left = `${left}%`;
      flake.style.fontSize = `${size}px`;
      flake.style.opacity = String(opacity);
      flake.style.animationDuration = `${dur}s`;
      flake.style.animationDelay = `${delay}s`;
      // alternate warm gold / cool silver
      const hue = Math.random() > 0.5 ? "42 85% 65%" : "220 10% 78%";
      flake.style.color = `hsl(${hue} / ${opacity})`;
      el.appendChild(flake);
    }
  }, [count]);

  return <div ref={ref} className="snow-container" aria-hidden="true" />;
}
